import { Colors } from '@amelio/ui-library';

interface HandDrawnHighlightProps {
    width: number;
}

export const HandDrawnHighlight = ({ width }: HandDrawnHighlightProps) => {
    return (
        <svg
            className={'absolute overflow-visible'}
            style={{
                zIndex: 0,
                width: `${width - 12}px`,
                height: '45px',
                left: '-8px',
                top: '-8px',
            }}
            viewBox={'0 0 135 75'}
            preserveAspectRatio={'none'}
            aria-hidden={'true'}
        >
            <path
                d={
                    'M10,40 C8,34 10,26 14,20 C18,14 26,10 38,8 C52,6 68,8 84,12 C100,16 112,24 118,32 C122,38 120,44 116,48'
                }
                fill={'none'}
                stroke={Colors.PRIMARY}
                strokeWidth={'2'}
                strokeLinecap={'round'}
                strokeLinejoin={'round'}
                vectorEffect={'non-scaling-stroke'}
            />

            <path
                d={
                    'M116,48 C112,56 104,60 92,62 C76,64 58,62 42,58 C28,54 18,50 12,46 C8,43 6,40 8,37'
                }
                fill={'none'}
                stroke={Colors.PRIMARY}
                strokeWidth={'2'}
                strokeLinecap={'round'}
                strokeLinejoin={'round'}
                vectorEffect={'non-scaling-stroke'}
            />
        </svg>
    );
};
